"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SL_VIEW_ROLE_BY_STANDARD_ROLE = exports.SL_VIEW_ROLE_VALUES = exports.SL_VIEW_ROLE_KEY = void 0;
exports.classifyDatabaseRole = classifyDatabaseRole;
/**
 * sl-bpu6.4 Decision #4: DatabaseBlock role marker.
 *
 * Stored in BlockSuite DatabaseBlock props as `sl_view_role` to tag whether
 * the database is an AppBase ConfigDB or one of the database-native
 * standard Site databases. Used by ConfigProvisioner (new creation), the
 * adoption path (fail-loud when a user-DB is already marked), and the editor
 * (resolves sibling DBs).
 */
exports.SL_VIEW_ROLE_KEY = 'sl_view_role';
exports.SL_VIEW_ROLE_VALUES = {
    CONFIG: 'view-config',
    BRANDING: 'view-branding',
    CLUSTERS: 'view-clusters',
    TOPICS: 'view-topics',
    USERS: 'view-users',
    CONTENT: 'view-content',
    TRANSLATIONS: 'view-translations',
    FORMS: 'view-forms',
    SUBMISSIONS: 'view-submissions',
    // sl-sbux.8.1: database-native styling roles. StyleVariants got its
    // own role in the 2026-05-23 amendment so each variant carries its
    // own CRUD lifecycle + a many-to-one relation back to its preset.
    THEMES: 'view-themes',
    MOTION_SPECS: 'view-motion-specs',
    STYLE_PRESETS: 'view-style-presets',
    STYLE_VARIANTS: 'view-style-variants',
    CUSTOM_SHEETS: 'view-custom-sheets',
    CUSTOM_HTML_BLOCKS: 'view-custom-html-blocks',
    TEXTS: 'view-texts',
};
exports.SL_VIEW_ROLE_BY_STANDARD_ROLE = {
    config: exports.SL_VIEW_ROLE_VALUES.CONFIG,
    branding: exports.SL_VIEW_ROLE_VALUES.BRANDING,
    clusters: exports.SL_VIEW_ROLE_VALUES.CLUSTERS,
    topics: exports.SL_VIEW_ROLE_VALUES.TOPICS,
    users: exports.SL_VIEW_ROLE_VALUES.USERS,
    content: exports.SL_VIEW_ROLE_VALUES.CONTENT,
    translations: exports.SL_VIEW_ROLE_VALUES.TRANSLATIONS,
    forms: exports.SL_VIEW_ROLE_VALUES.FORMS,
    submissions: exports.SL_VIEW_ROLE_VALUES.SUBMISSIONS,
    themes: exports.SL_VIEW_ROLE_VALUES.THEMES,
    motionSpecs: exports.SL_VIEW_ROLE_VALUES.MOTION_SPECS,
    stylePresets: exports.SL_VIEW_ROLE_VALUES.STYLE_PRESETS,
    styleVariants: exports.SL_VIEW_ROLE_VALUES.STYLE_VARIANTS,
    customSheets: exports.SL_VIEW_ROLE_VALUES.CUSTOM_SHEETS,
    customHtmlBlocks: exports.SL_VIEW_ROLE_VALUES.CUSTOM_HTML_BLOCKS,
    texts: exports.SL_VIEW_ROLE_VALUES.TEXTS,
};
/**
 * Classify a DatabaseBlock's role by inspecting its properties. Accepts any
 * lookup function so callers can pass either a block-model-props object or a
 * y-map get-accessor (scanner vs provisioner).
 *
 * `lookup(key)` must return the same value BlockSuite would expose under
 * `props[key]` for `sl_view_role`. Returns `undefined` when the property is
 * absent.
 */
function classifyDatabaseRole(lookup) {
    const role = lookup(exports.SL_VIEW_ROLE_KEY);
    if (role === exports.SL_VIEW_ROLE_VALUES.CONFIG) {
        return 'config';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.CONTENT) {
        return 'content';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.BRANDING) {
        return 'branding';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.CLUSTERS) {
        return 'clusters';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.TOPICS) {
        return 'topics';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.USERS) {
        return 'users';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.TRANSLATIONS) {
        return 'translations';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.FORMS) {
        return 'forms';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.SUBMISSIONS) {
        return 'submissions';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.THEMES) {
        return 'themes';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.MOTION_SPECS) {
        return 'motionSpecs';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.STYLE_PRESETS) {
        return 'stylePresets';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.STYLE_VARIANTS) {
        return 'styleVariants';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.CUSTOM_SHEETS) {
        return 'customSheets';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.CUSTOM_HTML_BLOCKS) {
        return 'customHtmlBlocks';
    }
    if (role === exports.SL_VIEW_ROLE_VALUES.TEXTS) {
        return 'texts';
    }
    if (role === undefined || role === null || role === '') {
        return 'adoptable';
    }
    return 'foreign';
}
